import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "@/contexts/UserContext";
import { FullPageLoadingSpinner } from "@/components/ui/loading-spinner";

interface PublicRouteProps {
  children: React.ReactNode;
}

/**
 * Public route guard for unauthenticated users only
 * Redirects to dashboard if user is already authenticated
 * Shows loading spinner while validating authentication
 */
export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useUser();

  // Show loading spinner while validating authentication
  if (isLoading) {
    return <FullPageLoadingSpinner />;
  }

  // Redirect to dashboard if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

